<template>
    <b-nav-item-dropdown
        class="help-menu"
        id="topo-ajuda"
        right
        ref="navdropdown"
        v-if="$app.ocultar_tutorial == 0"
    >
        <template #button-content>
            <i class="fa fa-question-circle"></i>
        </template>
        <li 
            class="header"
        >
            Ajuda
        </li>
        <li>
            <ul class="menu">
                <li 
                    v-for="topico in topicos" 
                    :key="topico.nome"
                >
                    <a 
                        :href="topico.link" 
                        :target="topico.target"
                        @click="$refs.navdropdown.hide()"
                    >
                        <h3>
                            <div>
                                <i :class="topico.icone"></i> 
                                {{ topico.nome }}
                            </div>
                            <span 
                                class = "text-muted"
                            >
                                {{ topico.descricao }}
                            </span>
                        </h3>
                    </a>
                </li>
            </ul>
        </li>
    </b-nav-item-dropdown>
</template>
<script>
export default {
    data(){
        return {
            topicos: [
                {
                    nome: 'Central de ajuda', 
                    icone: 'fa fa fa-list-alt', 
                    descricao: 'Encontre aqui soluções e respostas rápidas', 
                    link: this.$urlBase + '/ajuda',
                    target: '_self'
                },
                {
                    nome: 'Vídeos tutoriais', 
                    icone: 'fa fa-caret-square-o-right', 
                    descricao: 'Aprenda sobre os recursos do sistema', 
                    link: this.$urlBase + '/ajuda/videos_tutoriais',
                    target: '_self'
                }
            ]
        }
    }
}
</script>